"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgCadDrawingFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M10.12 13.68L13 15.23l2.88-1.55L13 12.13l-2.88 1.55zM14 20.06l3-1.61v-3.1l-3 1.61v3.1zM9 18.45l3 1.61v-3.1l-3-1.61v3.1z" }),
        React.createElement("path", { d: "M25 23h-2V6H3v21h21.88a2 2 0 10.12-4zm-6-3.36l-6 3.22-6-3.22v-6.56l6-3.21 6 3.21z" }),
        React.createElement("path", { d: "M25.75 3H25v18a4.06 4.06 0 013.91 3.37 3.18 3.18 0 00.06-.62V6.25A3.26 3.26 0 0025.75 3z" })));
}
exports.default = SvgCadDrawingFilled;
//# sourceMappingURL=CadDrawingFilled.js.map